import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {
  // Initialisation persistante via LocalStorage [4]
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem("mmj_cart");
    return saved ? JSON.parse(saved) : [];
  });

  // Persistance automatique à chaque modification [4]
  useEffect(() => {
    localStorage.setItem("mmj_cart", JSON.stringify(items));
  }, [items]);

  // AJOUT D'UN PRODUIT (CORRIGÉ)
  const addItem = (product) => {
  setItems((prev) => {
    // CORRECTION : on compare avec product.id (l'objet qui arrive dans la fonction)
    const existing = prev.find((i) => i.product_id === product.id);
    
    if (existing) {
      return prev.map((i) =>
        i.product_id === product.id ? { ...i, quantity: i.quantity + 1 } : i
      );
    }

    return [
      ...prev,
      {
        product_id: product.id, // On transforme 'id' en 'product_id' pour le backend
        title: product.title,
        price_mc: product.price_mc,
        quantity: 1,
      },
    ];
  });
};

  // SUPPRESSION D'UN PRODUIT [5]
  const removeItem = (product_id) => {
    setItems((prev) => prev.filter((item) => item.product_id !== product_id));
  };

  // MISE À JOUR DE LA QUANTITÉ [5]
  const updateQuantity = (product_id, quantity) => {
    setItems((prev) =>
      prev.map((item) =>
        item.product_id === product_id 
          ? { ...item, quantity: Math.max(1, quantity) } 
          : item
      )
    );
  };

  // VIDER LE PANIER [5]
  const clearCart = () => setItems([]);

  // CALCULS DES TOTAUX [5]
  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);
  const totalPrice = items.reduce((sum, i) => sum + i.price_mc * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        addItem,
        removeItem,
        updateQuantity,
        clearCart,
        totalItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}